import React, { Component } from "react";
import ReactTable from "react-table";
import { Modal } from "reactstrap";
import { useForm } from "react-hook-form";
import VideoCatalogueModule from "..";
import { Link } from "react-router-dom";
import { resolveAssetUrl } from "../../../shared/utils";
import { Subscription, LectureVideo } from "lakshya-shared";
import fileSize from "filesize";

const defaultImage = require("./../assets/images/default-image.png");
const PAGE_SIZE = 100;

export default class LectureListing extends Component<any, any> {
  private fetchTimeout: ReturnType<typeof setTimeout> | null = null;

  constructor(props: any) {
    super(props);

    this.state = {
      isNewModalOpen: false,
      lectures: [],
      pages: 1,
      loading: true,
      page: 0,
      search: "",
    };
    this.toggleAddModal = this.toggleAddModal.bind(this);
    this.handleAddClick = this.handleAddClick.bind(this);
    this.handleFetch = this.handleFetch.bind(this);
    this.onFetchData = this.onFetchData.bind(this);
  }

  toggleAddModal() {
    this.setState({
      isNewModalOpen: !this.state.isNewModalOpen,
    });
  }

  handleAddClick = (data: any) => {
    const module: VideoCatalogueModule = this.props.module;
    const history = this.props.history;
    module.services
      .addLecture(data.title)
      .then((response: any) => {
        this.toggleAddModal();
        history.push(`/admin/videos/lectures/${response._id}`);
      })
      .catch((e) => {
        this.props.module.showError(
          "Lecture cannot be added",
          e.message ? e.message : "Network error",
          true
        );
      });
  };

  handleFetch(page: number = 0, search: string = "") {
    const module: VideoCatalogueModule = this.props.module;
    this.setState({ loading: true });
    module.services
      .getAllLectures({ page, limit: PAGE_SIZE, search })
      .then((response: any) => {
        this.setState({
          lectures: response?.lectures || [],
          pages: response?.pages || 1,
          page: response?.page ?? page,
          search,
          loading: false,
        });
        module.controller.fetchLecture(response?.lectures || []);
      })
      .catch((e) => {
        this.setState({ loading: false });
        this.props.module.showError(
          "Fetching course failed",
          e.message ? e.message : "Network error",
          true
        );
      });
  }

  onFetchData(state: any) {
    const titleFilter = (state.filtered || []).find(
      (f: any) => f.id === "title"
    );
    const search = titleFilter?.value ? String(titleFilter.value).trim() : "";
    const searchChanged = search !== this.state.search;
    const page = searchChanged ? 0 : state.page || 0;

    if (this.fetchTimeout) {
      clearTimeout(this.fetchTimeout);
    }

    // Debounce while typing in the search filter
    this.fetchTimeout = setTimeout(
      () => {
        this.handleFetch(page, search);
      },
      searchChanged && search ? 400 : 0
    );
  }

  componentWillUnmount() {
    if (this.fetchTimeout) {
      clearTimeout(this.fetchTimeout);
    }
  }

  render() {
    const { lectures, pages, loading } = this.state;
    return (
      <>
        <div className="col-12">
          <div className="sticky-button-wrapper py-4 pr-3 d-flex justify-content-between align-items-center">
            <h4>Lecture Video Manager</h4>
            <button
              onClick={this.toggleAddModal}
              className="add-lecture-button-wrapper px-5 py-3"
            >
              Add Lecture
            </button>
          </div>
          <div className="pt-3">
            <ReactTable
              manual
              minRows={3}
              defaultPageSize={PAGE_SIZE}
              pageSizeOptions={[PAGE_SIZE]}
              page={this.state.page}
              pages={pages}
              data={lectures}
              loading={loading}
              onFetchData={this.onFetchData}
              columns={[
                {
                  Header: "Title",
                  accessor: "title",
                  filterable: true,
                  Cell: (row) => {
                    const lecture = row.original;
                    return (
                      <div className="d-flex">
                        <img
                          width={124}
                          src={
                            lecture.bannerImageId
                              ? resolveAssetUrl(lecture.bannerImageId, "public")
                              : defaultImage
                          }
                          alt="Video thumbnail"
                        />
                        <Link
                          className="text-primary ml-3"
                          rel="noopener noreferrer"
                          to={`/admin/videos/lectures/${row.original._id}`}
                        >
                          {row.value}
                        </Link>
                      </div>
                    );
                  },
                },
                {
                  Header: "Status",
                  accessor: "isPublished",
                  width: 100,
                  filterable: false,
                  Cell: (row) => {
                    return (
                      <span
                        className={`${
                          row.value === true
                            ? "text-success"
                            : "text-danger font-weight-bold"
                        }`}
                      >
                        {row.value === true ? "Published" : "Unpublished"}
                      </span>
                    );
                  },
                },
                {
                  Header: "Subscription",
                  accessor: "masterSubscription",
                  filterable: false,
                  Cell: (row) => {
                    const subscription: Subscription = row.value;
                    if (subscription) {
                      return (
                        <Link
                          target="_blank"
                          className="text-success"
                          rel="noopener noreferrer"
                          to={`/admin/subscriptions/editor/${
                            (subscription as any)._id
                          }`}
                        >
                          {subscription.title}
                          <i className="fas fa-external-link-alt ml-3"></i>
                        </Link>
                      );
                    } else {
                      return (
                        <span className="text-muted">No Associations</span>
                      );
                    }
                  },
                },
                {
                  Header: "Duration (File Size)",
                  accessor: "videoDurationInMinutes",
                  filterable: false,
                  Cell: (row) => {
                    const inMins: number = parseFloat(row.value);
                    const lecture: LectureVideo = row.original;
                    const hasVideo = lecture.videoResourceId !== null;
                    if (hasVideo) {
                      return (
                        <>
                          {!isNaN(inMins) ? (
                            <>
                              <span className="text-muted">{`${inMins} Mins.`}</span>
                              <br />
                            </>
                          ) : null}
                          <span className="text-muted">{`File: ${fileSize(
                            lecture.videoFileSizeInBytes
                          )}`}</span>
                        </>
                      );
                    } else {
                      return (
                        <span className="text-danger">Video not uploaded</span>
                      );
                    }
                  },
                },
                {
                  Header: "Notes (PDF)",
                  accessor: "notes",
                  filterable: false,
                  Cell: (row) => {
                    const notes: any[] = row.value;
                    return (
                      <span className="text-muted">
                        {notes.length > 0
                          ? `${notes.length} Note(s)`
                          : "No Notes Attached"}
                      </span>
                    );
                  },
                },
              ]}
            />
          </div>
        </div>
        {/* @ts-ignore */}
        <Modal
          autoFocus={true}
          centered={true}
          toggle={this.toggleAddModal}
          isOpen={this.state.isNewModalOpen}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">New Lecture</h5>
              <button
                type="button"
                onClick={this.toggleAddModal}
                className="close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <AddLectureForm
                handleAddClick={this.handleAddClick}
                toggleAddModal={this.toggleAddModal}
              />
            </div>
          </div>
        </Modal>
      </>
    );
  }
}

function AddLectureForm(props: any) {
  const { register, handleSubmit, errors } = useForm();
  const toggleAddModal = props.toggleAddModal;
  const handleAddClick = props.handleAddClick;

  return (
    <form onSubmit={handleSubmit(handleAddClick)}>
      <input
        autoFocus={true}
        autoComplete="off"
        name="title"
        ref={register({ required: true })}
        type="text"
        className="form-control"
        placeholder="Enter Title"
      />
      {errors.title && (
        <small className="text-danger" id="otp-error">
          Please provide a title
        </small>
      )}
      <div className="modal-footer">
        <button
          type="button"
          onClick={toggleAddModal}
          className="btn btn-default"
        >
          Cancel
        </button>
        <button type="submit" className="btn btn-primary">
          Create Lecture
        </button>
      </div>
    </form>
  );
}
